import { Component, DestroyRef, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { API, PoolDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'app-pool-edit',
  templateUrl: './pool-edit.component.html',
  styleUrls: ['./pool-edit.component.scss'],
  standalone: false,
})
export class PoolEditComponent implements OnInit {
  loading: boolean;
  poolId: number;
  debounceTimer: ReturnType<typeof setTimeout>;
  pool: PoolDTO;
  editMode: boolean;

  form = new UntypedFormGroup({
    Name: new UntypedFormControl('', [Validators.required]),
    Description: new UntypedFormControl('', []),
  });

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    private errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {
    this.loading = true;
    this.pool = undefined;
    this.poolId = undefined;
    this.debounceTimer = null;
    this.editMode = false;
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.poolId = +params.poolID;
      if (this.poolId) {
        this.editMode = true;

        this.requestDebounced();
      } else {
        this.editMode = false;

        this.pool = this.api.createDTO('PoolDTO');

        this.loading = false;
      }
    });
  }

  get Name() {
    return this.form.get('Name');
  }

  get Description() {
    return this.form.get('Description');
  }

  requestDebounced() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    this.api
      .ss_nm_Pool_retrieveById(this.poolId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (data: PoolDTO) => {
          this.pool = data;

          this.refreshFormFromDTO();
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }

  refreshFormFromDTO() {
    this.Name.setValue(this.pool.name);
    this.Description.setValue(this.pool.description);
  }

  refreshDTOFromForm() {
    this.pool.name = this.Name.value;
    this.pool.description = this.Description.value;
  }

  submit() {
    this.loading = true;
    this.refreshDTOFromForm();

    let obs;

    if (this.editMode) {
      obs = this.api.ss_nm_Pool_edit(this.pool);
    } else {
      obs = this.api.ss_nm_Pool_create(this.pool);
    }

    if (obs) {
      obs
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: data => {
            this.pool = data;

            this.refreshFormFromDTO();

            this.util.returnToNavigation(this.util.RoutingID.pools);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  cancel() {
    this.util.returnToNavigation(this.util.RoutingID.pools);
  }
}
